export const LOGIN_ROUTE = '/auth/login';
export const HOME_ROUTE = '/user/users-cards';

export const ORDER_ASC = 'ASC';
export const ORDER_DESC = 'DESC';

export const API_AUTH_LOGIN = '/login';
export const API_AUTH_LOGOUT = '/logout';
